import pkg from "#basepath/package.json";
import { APP_CONFIG_RM } from "#config/residencial-maya/constants/app-config.constant";
import { COMPANY_CONFIG_RM } from "#config/residencial-maya/constants/company-config.constant";
import { Environment } from "#root/config/interfaces/environment.interface";

export const environment: Environment = {
  version: pkg.version,
  hmr: false,
  production: true,
  baseUrl: "https://rm-crm-prod-as.azurewebsites.net/api/v1/",
  googleMapsKey: "AIzaSyDechfrh9791fuTOLLmzp1_BsB4s6Rd5LE",
  googleClientId:
    "280882478275-740o35ja86skqlnl91dgrr3t481pqr84.apps.googleusercontent.com",
  sentryDSN: "https://o4505172191608832.ingest.us.sentry.io/4510964523663360",
  googleAnalyticsId: "G-GCXSC8LC2L",
  appTitle: (title: string) =>
    `${title ? `${title} | ` : ""}${APP_CONFIG_RM.appName} - Panel Administrativo`,

  appConfig: {
    ...APP_CONFIG_RM,
  },

  companyConfig: {
    ...COMPANY_CONFIG_RM,
  },
};
